import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.farm.trash');
import { OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-farm-trash',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.farm.trash/view.scss */
:host {
  display: block;
}`],
})
export class PortalFarmTrashComponent implements OnInit {

    @ViewChild('modalMessage') modalMessage: any;

    public list: any[] = [];
    public search: any = { page: 1 };
    public facet: any = { lastpage: 1 };
    public emptyMessage = '휴지통에 이동된 농장이 없습니다.';
    public processingFarmId = '';
    public processingAction = '';

    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    public async ngOnInit() {
        await this.service.init(null);
        await this.load();
        await this.service.render();
    }

    public async load() {
        const res: any = await wiz.call('search', this.search);
        if (res.code === 200) {
            this.list = res.data.list;
            this.facet.lastpage = res.data.lastpage;
            this.emptyMessage = '휴지통에 이동된 농장이 없습니다.';
            return;
        }

        this.list = [];
        this.facet.lastpage = 1;
        this.emptyMessage = res?.code === 401 || res?.code === 403
            ? '휴지통 조회 권한이 없습니다.'
            : '휴지통 목록을 불러오지 못했습니다.';
    }

    public async page(p: number) {
        if (p < 1 || p > this.facet.lastpage) return;
        this.search.page = p;
        await this.load();
        await this.service.render();
    }

    public goList() {
        this.router.navigate(['/admin/farm/list']);
    }

    private async reloadAfterRemove() {
        if (this.list.length === 1 && this.search.page > 1) {
            this.search.page -= 1;
        }

        await this.load();
    }

    public async restoreFarm(event: Event, item: any) {
        event.stopPropagation();

        if (!item?.farm_id || this.processingFarmId) return;

        this.processingFarmId = item.farm_id;
        this.processingAction = 'restore';
        await this.service.render();

        try {
            const res: any = await wiz.call('restore', { farm_id: item.farm_id });

            if (res?.code === 200) {
                await this.reloadAfterRemove();
                await this.modalMessage.open({ message: '농장이 복구되었습니다.' });
                return;
            }

            if (res?.code === 401 || res?.code === 403) {
                await this.modalMessage.open({ message: '농장 복구 권한이 없습니다.' });
                return;
            }

            if (res?.code === 404) {
                await this.reloadAfterRemove();
                await this.modalMessage.open({ message: '이미 삭제되었거나 존재하지 않는 농장입니다.' });
                return;
            }

            if (res?.code === 409) {
                await this.reloadAfterRemove();
                await this.modalMessage.open({ message: '휴지통에 없는 농장입니다.' });
                return;
            }

            await this.modalMessage.open({ message: '농장 복구에 실패했습니다.' });
        } catch (error) {
            console.error('farm restore error:', error);
            await this.modalMessage.open({ message: '농장 복구 중 오류가 발생했습니다.' });
        } finally {
            this.processingFarmId = '';
            this.processingAction = '';
            await this.service.render();
        }
    }

    public async permanentDeleteFarm(event: Event, item: any) {
        event.stopPropagation();

        if (!item?.farm_id || this.processingFarmId) return;

        const confirmed = await this.modalMessage.open({
            title: '농장 영구 삭제',
            messageLines: [
                [
                    { text: item.farm_name, class: 'text-blue-600 font-medium' },
                    { text: '을 ' },
                    { text: '영구 삭제', class: 'text-[#cd201f] font-medium' },
                    { text: '하시겠습니까?' }
                ],
                [
                    { text: '영구 삭제된 농장 정보는 복구할 수 없습니다.' }
                ]
            ],
            btnAction: '영구 삭제',
            btnClose: '취소',
            btnClass: 'bg-[#cd201f] hover:bg-[#cd201f]/80 px-4 py-1.5 text-white'
        });

        if (!confirmed) return;

        this.processingFarmId = item.farm_id;
        this.processingAction = 'delete';
        await this.service.render();

        try {
            const res: any = await wiz.call('permanent_delete', { farm_id: item.farm_id });

            if (res?.code === 200) {
                await this.reloadAfterRemove();
                await this.modalMessage.open({ message: '농장이 영구 삭제되었습니다.' });
                return;
            }

            if (res?.code === 401 || res?.code === 403) {
                await this.modalMessage.open({ message: '농장 영구 삭제 권한이 없습니다.' });
                return;
            }

            if (res?.code === 404) {
                await this.reloadAfterRemove();
                await this.modalMessage.open({ message: '이미 삭제되었거나 존재하지 않는 농장입니다.' });
                return;
            }

            if (res?.code === 409) {
                await this.reloadAfterRemove();
                await this.modalMessage.open({ message: '휴지통에 없는 농장입니다.' });
                return;
            }

            await this.modalMessage.open({ message: '농장 영구 삭제에 실패했습니다.' });
        } catch (error) {
            console.error('farm permanent delete error:', error);
            await this.modalMessage.open({ message: '농장 영구 삭제 중 오류가 발생했습니다.' });
        } finally {
            this.processingFarmId = '';
            this.processingAction = '';
            await this.service.render();
        }
    }

    public onPageChange = async (page: number) => {
        await this.page(page);
    }
}

export default PortalFarmTrashComponent;